export const Routes = {
  DOCS_HOME: '/docs',
  POLITICS_PAGE: '/docs/politics',
  AGREEMENT_PAGE: '/docs/agreement',
  PUBLIC_OFFER_PAGE: '/docs/public-offer',
};
